import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { readStoredMemberUser } from "@/features/public/memberSession";

export default function MemberPasswordChangeGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const storedUser = readStoredMemberUser();

  if (storedUser?.mustChangePassword && location.pathname !== "/membre") {
    return <Navigate to="/membre" replace />;
  }

  return <>{children}</>;
}
